import React, { Component } from 'react'
import { autobind } from 'react-decoration'
import cn from 'classnames'
import { Motion, spring } from 'react-motion'

const tabWidth = 150

const Tab = ({ children, active, onClick }) => {
  return (
    <div className={cn('tab', { active })} onClick={onClick}>
      {children}
      <style jsx>{`
        .tab {
          box-sizing: border-box;
          font-size: 17px;
          color: rgba(0, 0, 0, 0.56);
          display: flex;
          justify-content: center;
          padding-bottom: 8px;
          cursor: pointer;
        }
        .tab.active {
          font-weight: 500;
          color: rgba(0, 0, 0, 0.8);
        }
      `}</style>
    </div>
  )
}

class TabSwitcher extends Component {
  constructor(props) {
    super()
    this.state = {
      currentTab: props.defaultTab,
    }
  }
  @autobind
  handleTabClick(idx) {
    this.setState({
      currentTab: idx,
    })
    this.props.onTabChange(idx)
  }
  render() {
    const { tabs } = this.props
    const { currentTab } = this.state
    return (
      <div className="tab-switcher">
        <div className="tabs">
          {tabs.map((tab, idx) =>
            <div className="tab">
              <Tab
                active={idx === currentTab}
                key={idx}
                onClick={() => this.handleTabClick(idx)}
              >
                {tab}
              </Tab>
            </div>
          )}
        </div>
        <Motion style={{ x: spring(currentTab * tabWidth) }}>
          {({ x }) =>
            <div
              className="line"
              style={{
                transform: `translate3d(${x}px, 0, 0)`,
              }}
            />}
        </Motion>
        <style jsx>{`
          .tabs {
            display: flex;
            box-sizing: border-box;
            border-bottom: solid 2px #f4f4f7;
          }
          .tab {
            width: ${tabWidth}px;
          }
          .line {
            position: relative;
            bottom: 2px;
            background-color: #000000;
            height: 2px;
            width: ${tabWidth}px;
          }
        `}</style>
      </div>
    )
  }
}

export default TabSwitcher



// WEBPACK FOOTER //
// ./src/components/tabSwitcher/index.js